import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation UpdatePaymentAccount(
    $id: Int!
    $nickname: String!
    $payoutDescriptor: String!
  ) {
    updatePaymentAccount(
      id: $id
      input: {
        nickname: $nickname
        payout_descriptor: $payoutDescriptor
      }
    ) {
      bankAccountNumberLast4
      bankName
      bankRoutingNumber
      businessType
      country
      currency
      currentProcessorAccountId
      id
      insertedAt
      legalEntityName
      firstName
      lastName
      nickname
      paymentsEnabled
      payoutsEnabled
      processor
      scopeId
      scopeType
      paymentDescriptor
      payoutDescriptor
      status
    }
  }
`;
